"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTwoProngType = void 0;
/** @hidden */
function getTwoProngType(e) {
    if (e.holeClosing) {
        return 'twoProng_holeClosing';
    }
    return 'twoProng_regular';
}
exports.getTwoProngType = getTwoProngType;
//# sourceMappingURL=get-two-prong-type.js.map